// extracted by mini-css-extract-plugin
export default {"modale":"ExportModal_modale__+Xtr-","tabs":"ExportModal_tabs__aDp5O","bar":"ExportModal_bar__LUAgM","active":"ExportModal_active__5Fmq5","rotate":"ExportModal_rotate__coHj+"};